export interface NotificationContext {
    notifications: UserNotification[]
    notificationCount: number
}

export interface UserNotification {
    notificationDescription: string,
    notificationDate: string,
    notificationCategory: number,
    notificationLink: object,
    queryParams?: object
}

export enum NotificationCategory {
    ORDER = 0,
    INVITATION = 1,
    WITHDRAWAL = 2,
    BANKACCOUNT = 3
}